import { render, staticRenderFns } from "./CaseVoicePrint.vue?vue&type=template&id=287e23e4"
import script from "./CaseVoicePrint.vue?vue&type=script&lang=js"
export * from "./CaseVoicePrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports